export const FONT_SCALE_STORAGE_KEY = 'coonaltragas_font_scale';

/** Porcentaje del tamaño base del navegador (100 = estándar del navegador). */
export const FONT_SCALE_STEPS = [100, 110, 120, 130, 140];

/** Tamaño global por defecto del portal (primera visita). */
const DEFAULT_STEP = 110;

export function clampFontScale(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return DEFAULT_STEP;
  const min = FONT_SCALE_STEPS[0];
  const max = FONT_SCALE_STEPS[FONT_SCALE_STEPS.length - 1];
  return Math.min(max, Math.max(min, n));
}

export function readStoredFontScale() {
  try {
    const raw = localStorage.getItem(FONT_SCALE_STORAGE_KEY);
    if (raw == null) return DEFAULT_STEP;
    return clampFontScale(Number(raw));
  } catch {
    return DEFAULT_STEP;
  }
}

export function applyFontScale(percent) {
  const value = clampFontScale(percent);
  document.documentElement.style.fontSize = `${value}%`;
  document.documentElement.dataset.fontScale = String(value);
  return value;
}

export function persistFontScale(percent) {
  const value = clampFontScale(percent);
  try {
    localStorage.setItem(FONT_SCALE_STORAGE_KEY, String(value));
  } catch {
    /* ignore */
  }
  return applyFontScale(value);
}

export function initFontScaleFromStorage() {
  return applyFontScale(readStoredFontScale());
}

export function stepFontScale(current, direction) {
  const idx = FONT_SCALE_STEPS.indexOf(clampFontScale(current));
  const safeIdx = idx >= 0 ? idx : FONT_SCALE_STEPS.indexOf(DEFAULT_STEP);
  const next =
    direction === 'up'
      ? FONT_SCALE_STEPS[Math.min(safeIdx + 1, FONT_SCALE_STEPS.length - 1)]
      : FONT_SCALE_STEPS[Math.max(safeIdx - 1, 0)];
  return persistFontScale(next);
}
